import { Controller } from "@hotwired/stimulus";

// Dialog around the account phone editor frame.
// Opens when the frame loads an editing step; closes when a summary
// state (cancel, same-number, or verified) connects inside it.
export default class extends Controller {
  static targets = ["dialog", "frame", "summary"];

  open() {
    // On cancel the summary connects (closing the dialog) before Turbo
    // dispatches turbo:frame-load, and the close handler may already have
    // emptied the frame, so both states mean "nothing to show".
    if (this.hasSummaryTarget || !this.frameTarget.firstElementChild) return;
    const codeStep = this.frameTarget.querySelector(".account-phone-code");
    this.dialogTarget.classList.toggle("vc-phone-dialog--code", Boolean(codeStep));
    this.dialogTarget.setAttribute("aria-labelledby", codeStep ? "account-phone-code-title" : "phone-dialog-title");
    if (!this.dialogTarget.open) this.dialogTarget.showModal();
    codeStep?.querySelector('input[autocomplete="one-time-code"]')?.focus({ preventScroll: true });
  }

  close() {
    if (this.hasDialogTarget && this.dialogTarget.open) this.dialogTarget.close();
  }

  closeOnBackdropClick(event) {
    if (event.target === event.currentTarget) this.close();
  }

  clear() {
    this.frameTarget.replaceChildren();
    this.frameTarget.removeAttribute("src");
  }

  summaryTargetConnected() {
    this.close();
  }
}
